import {
  CANCEL_OFFER,
  GET_LIGHT_ENTREPRENEURS_SUCCESS,
  LIGHT_ENTREPRENEURS_PAGE_CHANGE,
  LOCATION_CHANGE,
  // OFFER_AN_ASSIGNMENT_AGREEMENT,
  // COMPLETE_OFFER_FORM,
  ADD_LIGHT_ENTREPRENEURS_SUCCESS,
  CLOSE_LIGHT_ENTREPRENEURS_SNACKBAR,
  ADD_LIGHT_ENTREPRENEURS_FAILED,
  SET_FAVOURITE_ENTREPRENEURS_FAILED
  // PREVIEW_CONTRACT_SUCCESS,
  // PREVIEW_CONTRACT_FAILED,
  // SIGN_CONTRACT_SCREEN,
  // CLOSE_SIGN_CONTRACT_SCREEN,
  // SIGN_AND_SEND_CONTRACT_SUCCESS,
  // SIGN_AND_SEND_CONTRACT_FAILED,
  // OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM,
  // CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM,
  // CLOSE_ASSIGNMENT_FORM_DIALOG,
  // ADD_NEW_ASSIGNMENT_SUCCESS,
  // ADD_NEW_ASSIGNMENT
} from '../../constants/employer'

/**
 * @author Huong Nguyen
 */

const initialState = {
  lightEntre: [],
  selected: 0,
  isOffer: false, // ARE YOU SURE YOU WANT TO OFFER AN ASSIGNMENT?
  isCompleteForm: false, // Contract form
  offerToPerson: [], // Person to offer info
  showSuccessAddSnackbar: false, // Add light entrepreneurs success snackbar
  showFailedAddSnackbar: false, // Add light entrepreneurs failed snackbar
  showEmailNotExist: false, // Email is added not exist at Kassa
  showEmailAdded: false, // Email is added already
  enableSendOrSignButton: false, // Send or sign button at contract form
  signScreen: false, // Screen to sign the contract
  previewFormValues: [], // Form value when Preview action is triggered
  showSignAndSendSnackbar: false, // Sign and send successfully
  showSignAndSendFailedSnackbar: false, // Sign and send failed,
  openWarningCloseCompleteForm: false, // Warning close offer form will lost all filled data
  newAssignmentData: [],
  showAddFavouriteEntrepreneursFailedSnackbar: false,
  showRemoveFavouriteEntrepreneursFailedSnackbar: false,
  selectedLE: {},
  selectedLERatings: []
}

const lightEntrepreneursReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIGHT_ENTREPRENEURS_SUCCESS:
      const selectedLE = action.selectedLE
      const selectedLERatings =
        action.selectedLE !== undefined ? JSON.parse(selectedLE.ratings) : []
      return Object.assign(
        {},
        { ...state },
        {
          lightEntre: action.data,
          selected: state.selected,
          selectedLE: action.selectedLE,
          selectedLERatings: selectedLERatings
        }
      )

    case ADD_LIGHT_ENTREPRENEURS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSuccessAddSnackbar: true
        }
      )

    case ADD_LIGHT_ENTREPRENEURS_FAILED:
      const result = action.error

      let showEmailNotExist, showEmailAdded, showFailedAddSnackbar
      if (result === 'User details not existed') {
        showEmailNotExist = true
        showEmailAdded = false
        showFailedAddSnackbar = false
      } else if (result === 'Light Entrepreneurs email already exist') {
        showEmailAdded = true
        showEmailNotExist = false
        showFailedAddSnackbar = false
      } else {
        showFailedAddSnackbar = true
        showEmailNotExist = false
        showEmailAdded = false
      }
      return Object.assign(
        {},
        { ...state },
        {
          showFailedAddSnackbar: showFailedAddSnackbar,
          showEmailAdded: showEmailAdded,
          showEmailNotExist: showEmailNotExist
        }
      )
    case SET_FAVOURITE_ENTREPRENEURS_FAILED:
      return Object.assign(
        {},
        { ...state },
        action.error.isFavorite
          ? { showRemoveFavouriteEntrepreneursFailedSnackbar: true }
          : { showAddFavouriteEntrepreneursFailedSnackbar: true }
      )

    case CLOSE_LIGHT_ENTREPRENEURS_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSuccessAddSnackbar: false,
          showFailedAddSnackbar: false,
          showEmailAdded: false,
          showEmailNotExist: false,
          showSignAndSendSnackbar: false,
          showSignAndSendFailedSnackbar: false,
          showAddFavouriteEntrepreneursFailedSnackbar: false,
          showRemoveFavouriteEntrepreneursFailedSnackbar: false
        }
      )

    // case PREVIEW_CONTRACT_SUCCESS:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       enableSendOrSignButton: true,
    //       previewFormValues: action.data
    //     }
    //   )

    // case PREVIEW_CONTRACT_FAILED:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       enableSendOrSignButton: false
    //     }
    //   )

    // case SIGN_CONTRACT_SCREEN:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       signScreen: true
    //     }
    //   )
    // case CLOSE_SIGN_CONTRACT_SCREEN:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       signScreen: false
    //     }
    //   )
    // case SIGN_AND_SEND_CONTRACT_SUCCESS:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       showSignAndSendSnackbar: true,
    //       signScreen: false,
    //       isCompleteForm: false
    //     }
    //   )
    // case SIGN_AND_SEND_CONTRACT_FAILED:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       showSignAndSendFailedSnackbar: true
    //     }
    //   )

    case LIGHT_ENTREPRENEURS_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selected: action.selected.selected
        }
      )

    // case OFFER_AN_ASSIGNMENT_AGREEMENT:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       isCompleteForm: true,
    //       // isOffer: true,
    //       offerToPerson: action.selected
    //     }
    //   )
    // case CLOSE_ASSIGNMENT_FORM_DIALOG:
    // return Object.assign({}, { ...state }, { isCompleteForm: false })

    case CANCEL_OFFER:
      return Object.assign(
        {},
        { ...state },
        {
          isOffer: false,
          isCompleteForm: false,
          offerToPerson: [],
          enableSendOrSignButton: false,
          signScreen: false
          // openWarningCloseCompleteForm: false
        }
      )

    // case COMPLETE_OFFER_FORM:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       isCompleteForm: true,
    //       isOffer: false,
    //       openWarningCloseCompleteForm: false
    //     }
    //   )

    // case OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       openWarningCloseCompleteForm: true
    //     }
    //   )

    // case CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       openWarningCloseCompleteForm: false
    //     }
    //   )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selected: 0,
          isOffer: false,
          isCompleteForm: false,
          offerToPerson: [],
          showSuccessAddSnackbar: false,
          showFailedAddSnackbar: false,
          showEmailAdded: false,
          showEmailNotExist: false,
          enableSendOrSignButton: false,
          signScreen: false
          // openWarningCloseCompleteForm: false
        }
      )

    default:
      return state
  }
}

export default lightEntrepreneursReducer
